import { initializeConnector } from '@web3-react/core'
import { WalletConnect as WalletConnectV2 } from '@web3-react/walletconnect-v2'

// Normalize the network value from the environment
const normalizedNetwork = process.env.REACT_APP_NETWORK?.trim().toUpperCase(); // MAINNET | TESTNET

// Dynamically get the chain ID based on the selected network
const chainId = normalizedNetwork === 'MAINNET'
  ? parseInt(process.env.REACT_APP_MAINNET_CHAIN_ID, 10)
  : parseInt(process.env.REACT_APP_TESTNET_CHAIN_ID, 10);

export const [walletConnectV2, hooks] = initializeConnector(
  (actions) => {
    return new WalletConnectV2({
      actions,
      options: {
        projectId: "14808831369ecdaaab7b8869eb13c6b0",
        chains: [chainId], // Use the dynamically determined chain ID here
        optionalChains: [chainId],
        showQrModal: true
      },
      timeout: 10000,
      onError: (err) => {
        console.error('Error in connector:', err);
      }
    });
  }
);
